interface IReduxProps {
  color?: string;
}

const Redux: React.FC<IReduxProps> = (props) => {
  return (
    <svg
      width="51"
      height="50"
      viewBox="0 0 51 50"
      fill="none"
    >
      <path
        fill={props.color || "#000"}
        d="M34.77 34.506c1.845-.191 3.245-1.798 3.182-3.725a3.59 3.59 0 0 0-3.562-3.468h-.13c-1.972.062-3.5 1.733-3.437 3.725.067.964.448 1.797 1.02 2.375-2.164 4.306-5.472 7.452-10.437 10.085-3.37 1.8-6.87 2.442-10.368 1.992-2.865-.386-5.092-1.671-6.492-3.79-2.036-3.146-2.225-6.552-.508-9.956 1.208-2.44 3.118-4.24 4.327-5.138a35.392 35.392 0 0 1-.827-3.277C-1.69 30.075-.733 39.196 2.063 43.5c2.1 3.212 6.362 5.204 11.072 5.204a15.518 15.518 0 0 0 3.817-.45c8.146-1.604 14.317-6.487 17.817-13.746m11.198-7.964c-4.836-5.717-11.963-8.865-20.107-8.865h-1.018a3.494 3.494 0 0 0-3.117-1.927h-.13c-1.97.065-3.5 1.736-3.435 3.727.063 1.927 1.655 3.467 3.563 3.467h.13a3.586 3.586 0 0 0 3.116-2.184h1.146c4.835 0 9.416 1.413 13.552 4.175 3.18 2.121 5.473 4.882 6.743 8.223 1.084 2.696 1.021 5.33-.125 7.58-1.783 3.404-4.772 5.266-8.718 5.266-2.544 0-4.963-.77-6.236-1.35a37.65 37.65 0 0 1-2.862 2.313c2.735 1.285 5.535 1.991 8.208 1.991 6.108 0 10.625-3.404 12.344-6.808 1.844-3.725 1.716-10.148-3.054-15.608Zm-32.321 9.054c.062 1.927 1.654 3.469 3.562 3.469h.127c1.973-.063 3.5-1.734 3.438-3.725a3.59 3.59 0 0 0-3.563-3.47h-.129a1.104 1.104 0 0 0-.446.063c-2.608-4.366-3.69-9.118-3.308-14.258.254-3.854 1.527-7.194 3.754-9.956 1.846-2.375 5.409-3.531 7.827-3.596 6.744-.13 9.607 8.35 9.798 11.754.827.192 2.227.642 3.181.963-.764-10.405-7.125-15.8-13.235-15.8-5.725 0-11.006 4.175-13.106 10.341-2.927 8.221-1.019 16.121 2.546 22.352-.32.45-.51 1.157-.446 1.863Z"
      />
    </svg>
  );
};

export default Redux;
